export class Bussiness {
    get id() {
        return this.dussinessState.id;
    }
    get name() {
        return this.dussinessState.name;
    }
    get cif() {
        return this.dussinessState.cif;
    }
    get directionId() {
        return this.dussinessState.directionId;
    }
    constructor(dussinessState) {
        this.dussinessState = dussinessState;
    }
    getState() {
        return this.dussinessState;
    }
}
